export function getInterval(eventNum) {
    if(eventNum >= window.Json.game.length)
        return 10;
    
    var interval = window.Json.game[eventNum].interval;
    if(interval == null)
        return 5;
    if(interval == 0)
        return 3;

    return interval;
}

export function getIntervalFromEvent(event) {
    var interval = event.interval;
    if(interval == null)
        return 5;
    if(interval == 0)
        return 3;

    return interval;
}


/** WEBPACK FOOTER **
 ** ./src/components/Pitch/gameJson.js
 **/